module.exports = __webpack_public_path__ + "static/media/pound-sterling.ada4bb9d.svg";